import { render, staticRenderFns } from "./MaterialPriceTable.vue?vue&type=template&id=0735474c&scoped=true&"
import script from "./MaterialPriceTable.vue?vue&type=script&lang=js&"
export * from "./MaterialPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPriceTable.vue?vue&type=style&index=0&id=0735474c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0735474c",
  null
  
)

export default component.exports